import type { SeasonalCare } from '../../types/careExpanded';

interface SeasonalSectionProps {
  seasonal: SeasonalCare;
}

const SEASONS = [
  { key: 'spring' as const, icon: 'park', label: 'Spring', color: 'text-green-600 bg-green-500/10 border-green-500/20' },
  { key: 'summer' as const, icon: 'wb_sunny', label: 'Summer', color: 'text-amber-600 bg-amber-500/10 border-amber-500/20' },
  { key: 'autumn' as const, icon: 'eco', label: 'Autumn', color: 'text-orange-600 bg-orange-500/10 border-orange-500/20' },
  { key: 'winter' as const, icon: 'ac_unit', label: 'Winter', color: 'text-blue-600 bg-blue-500/10 border-blue-500/20' },
];

export function SeasonalSection({ seasonal }: SeasonalSectionProps) {
  const availableSeasons = SEASONS.filter((s) => seasonal[s.key]);

  if (availableSeasons.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">No seasonal care info available</p>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {availableSeasons.map(({ key, icon, label, color }) => (
        <div
          key={key}
          className={`p-3 rounded-lg border ${color}`}
        >
          <div className="flex items-center gap-2 mb-1.5">
            <span className="material-symbols-outlined" style={{ fontSize: 20 }} aria-hidden="true">{icon}</span>
            <span className="font-medium text-sm">{label}</span>
          </div>
          <p className="text-sm text-editorial-black">{seasonal[key]}</p>
        </div>
      ))}
    </div>
  );
}
